
import { useNavigate } from 'react-router-dom';
import { Search, Icon, Header, Message } from 'semantic-ui-react';

import { JoyyaHeader } from '../../../../components/JoyyaHeader';
import { usePeopleSearch } from '../shared/usePeopleSearch';
import { PersonListItem } from '../shared/PersonListItem';
import { PeopleListSkeleton, SearchSkeleton } from '../shared/PeopleSkeleton';
import { AdvancedFilters } from '../shared/AdvancedFilters';

import styles from './TeacherPeopleView.module.css';

const TeacherPeopleView = () => {
    const navigate = useNavigate();
    const {
        search,
        missingConsent,
        canLogin,
        hasAdvancedFilter,
        loading,
        data,
        handleSearchChange,
        handleMissingConsentChange,
        handleCanLoginChange,
        shouldShowSearch,
    } = usePeopleSearch();

    // Placeholder rows while loading with nothing to show yet. The real search
    // field is never replaced by a skeleton once visible; the skeleton bar only
    // fills the blank initial-load gap before shouldShowSearch is known.
    const showListSkeleton = loading && !data?.users?.length;

    return (
        <>
            <JoyyaHeader />
            <div className="mobile-frame">
                <Header as="h2">
                    <span className={styles.header}>
                        <Icon name="arrow left" className={styles.backBtn} onClick={() => navigate(-1)} />
                        People
                    </span>
                </Header>

                {shouldShowSearch ? (
                    <Search
                        loading={loading}
                        input={{ fluid: true }}
                        className={styles.search}
                        size="large"
                        placeholder="Search..."
                        open={false}
                        onSearchChange={handleSearchChange}
                        value={search}
                    />
                ) : loading ? (
                    <div className={styles.search}>
                        <SearchSkeleton />
                    </div>
                ) : null}

                {/* Renders nothing for a teacher — the component carries its own gate, so the
                    two People views cannot drift apart on who sees these. A centre manager
                    lands on this view rather than the admin one (PersonaSwitcher passes no
                    centerManagerView for People), which is why the filters have to exist here
                    at all. */}
                <AdvancedFilters
                    className={styles.search}
                    missingConsent={missingConsent}
                    canLogin={canLogin}
                    hasAdvancedFilter={hasAdvancedFilter}
                    onMissingConsentChange={handleMissingConsentChange}
                    onCanLoginChange={handleCanLoginChange}
                />

                <div>
                    {showListSkeleton
                        ? <PeopleListSkeleton count={8} />
                        : data?.users.map((p: any) => (
                            <PersonListItem
                                key={p.id}
                                person={p}
                                onClick={() => navigate(`/people/${p.id}`)}
                            />
                        ))}
                </div>

                {shouldShowSearch && !loading && data?.users.length > 10 && (
                    <Message style={{ marginTop: '1em' }}>
                        <Message.Header>Don't see who you're looking for?</Message.Header>
                        <p>Try a more specific search — we don't load everyone at once.</p>
                    </Message>
                )}
            </div>
        </>
    );
};

export { TeacherPeopleView };
